/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMoodCrazyHappy = createReactComponent("mood-crazy-happy", "IconMoodCrazyHappy", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M7 8.5l3 3", key: "svg-1" }],
  ["path", { d: "M7 11.5l3 -3", key: "svg-2" }],
  ["path", { d: "M14 8.5l3 3", key: "svg-3" }],
  ["path", { d: "M14 11.5l3 -3", key: "svg-4" }],
  ["path", { d: "M9.5 15a3.5 3.5 0 0 0 5 0", key: "svg-5" }]
]);

export { IconMoodCrazyHappy as default };
//# sourceMappingURL=IconMoodCrazyHappy.js.map
